import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ToasterManager } from "@wf/components";
import { KeycloakProvider } from "@wf/keycloak-axios-provider";
import TradeLayout from "./TradeLayout";

import Router from "./AppRoute";
import createStore from "../store/createStore";
import Loading from "./Loading";

const store = createStore();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
          <KeycloakProvider
              trackUserActivity
              sessionIdleMilliseconds={1000 * 60 * 60}
              loader={null}
          >
          <TradeLayout>
            <Router />
          </TradeLayout>
          </KeycloakProvider>
        <Loading />
        <ToasterManager />
      </BrowserRouter>
    </Provider>
  );
};

export default App;
